import { useEffect, useState } from "react";
import { subscribeToMonitoringRuns } from "../services/monitoringService";

export default function useMonitoringRuns(collectionId) {
  const [runs, setRuns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!collectionId) return undefined;
    setIsLoading(true);
    return subscribeToMonitoringRuns(collectionId, (nextRuns) => {
      setRuns(nextRuns);
      setIsLoading(false);
      setError("");
    }, (firebaseError) => {
      console.error("Unable to load monitoring runs", firebaseError);
      setError("Monitoring history could not be loaded.");
      setIsLoading(false);
    });
  }, [collectionId]);

  return { runs, isLoading, error };
}

